import React, { useEffect, useState } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { Alert, Box, CircularProgress } from '@mui/material';
import { publicStorefrontApi } from '../../services/storefrontService';
import { useStorefrontT } from '../../components/Storefront/useStorefrontT';

/** Alte Landing-Page-Links `/p/:slug` → `/store/:storefrontSlug` (ein Release lang, Plan 3.8). */
const LegacyLandingPageRedirect: React.FC = () => {
    const { slug = '' } = useParams<{ slug: string }>();
    const { t } = useStorefrontT();
    const [target, setTarget] = useState<string | null>(null);
    const [failed, setFailed] = useState(false);

    useEffect(() => {
        let cancelled = false;
        publicStorefrontApi
            .legacyLandingPage(slug)
            .then((d) => !cancelled && setTarget(d.slug))
            .catch(() => !cancelled && setFailed(true));
        return () => {
            cancelled = true;
        };
    }, [slug]);

    if (target) return <Navigate to={`/store/${target}`} replace />;
    if (failed) return <Box sx={{ p: 4, maxWidth: 560, mx: 'auto' }}><Alert severity="warning">{t('notFound')}</Alert></Box>;
    return <Box sx={{ display: 'flex', justifyContent: 'center', p: 8 }}><CircularProgress /></Box>;
};

export default LegacyLandingPageRedirect;
